import axios from 'axios';

axios.defaults.timeout = 210000;
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  if (localStorage.getItem('jwt') && config?.headers) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('jwt')}`;
  }

  return config;
});
